import React, { useRef } from 'react';
import { Popover } from 'antd';
import FixedContainer from '@base/lib/FixedContainer';
import Iconfont from '@base/lib/Iconfont';
// import { toggleZendesk } from 'base/utils/zendesk';
import { toggleZendesk } from 'base/utils/zendeskMessaging';
import { scrollToTop } from 'base/utils/scrollTo';
import DownAppContent from './DownAppContent';
import styles from './index.module.less';

const SideWidgets: React.FC = () => {
    const ref = useRef<HTMLDivElement>(null);
    return (
        <FixedContainer
            className={styles['side-widgets']}
            width={40}
            placement={['right', 'bottom']}
            offset={[0, 100]}
        >
            <Popover
                content={<DownAppContent/>}
                placement="leftBottom"
                getPopupContainer={triggerNode => ref.current || triggerNode}
                overlayClassName={styles['down-app']}
                showArrow={false}
            >
                <div className={styles.widget}>
                    <Iconfont className="icon-headphones"/>
                </div>
            </Popover>

            <div className={styles.widget} onClick={toggleZendesk}>
                <Iconfont className="icon-customer-service"/>
            </div>
            <div className={styles.widget} onClick={scrollToTop}>
                <Iconfont className="icon-top"/>
            </div>
            <div ref={ref} className="relative"></div>
        </FixedContainer>
    );
}

export default SideWidgets;
